export class SpeciesData {

  speciesName: string = ''; // unique

  speciesCode: string = ''; // Hart code used for input into FOS (not unique)

  sizeCode: string = ''; // only used for chinook species

  /* Fields for daily catch reports */

  kept!: number;

  released!: number;

  /* Fields for offload catch reports */

  offloadWeight: number = 0; // for seine reports only

  offloadPieces: number = 0;

  catchCategory: string = 'O'; //For sending to FOS only

  constructor(speciesName: string = '', speciesCode: string = '', kept: number = -1, released: number = -1) {
    this.speciesName = speciesName;
    this.speciesCode = speciesCode;
    this.kept = kept >=0 ? kept : this.kept;
    this.released = released >= 0 ? released : this.released;
  }

  public toString(): string {
    return this.speciesName;
  }

  public isValid(): boolean {
    return !!this.speciesName;
  }

  // transform object into Species Data
  public static transformAnonymous(speciesData: any): SpeciesData {

    // if object does not exist, create new species data
    if (!speciesData) {
      return new SpeciesData();
    }

    let species: SpeciesData = new SpeciesData(speciesData.speciesName ?? '');
    species.speciesCode = speciesData.speciesCode ?? '';
    species.sizeCode = speciesData.sizeCode ?? '';
    species.kept = speciesData.kept;
    species.released = speciesData.released;
    species.offloadWeight = speciesData.offloadWeight ?? 0;
    species.offloadPieces = speciesData.offloadPieces ?? 0;
    species.catchCategory = speciesData.catchCategory ?? 'O';
    return species;
  }

  // check if species data list is defined
  public static transformAnonArray(speciesDataList: any): SpeciesData[] {

    // if list does not exist, set an empty array
    if (!speciesDataList) {
      return [];
    }

    let thisSpeciesDataList: SpeciesData[] = [];
    for (let speciesData of speciesDataList) {
      thisSpeciesDataList.push(SpeciesData.transformAnonymous(speciesData));
    }
    return thisSpeciesDataList;
  }

}
